import { itemsPagination, listLoadingProgress, loadingProgress } from '~/data/reducers/scopes';
import * as schemas from '~/data/utils/schemas';
import { Map } from 'immutable';
import { denormalize } from 'normalizr';

const getState = (store) => store.scopes;

const getEntities = (store) => getState(store).get('entities');

export const getItem = (store, id) => getEntities(store).get(id);

export const getItems = (store) => {
  const entities = Map({
    scopes: getEntities(store),
  });
  return denormalize(itemsPagination.getPageItems(getState(store)), [schemas.scope], entities);
};

export const itemLoaded = (store) => loadingProgress.getLoaded(getState(store));

export const itemsLoaded = (store) => listLoadingProgress.getLoaded(getState(store));

export const getTotalItems = (store) => itemsPagination.getTotalItems(getState(store));
